export default {
    loading: {
        count: 0,
        locale: 'content', // 'content' or 'page'
    },
};